const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop-intelligence/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PermissionDeniedError } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
const REQUIRED_PERMISSION: Permission = 'view_recommendations';
interface LoopIntelligenceBeforeLoadArgs {
  context: {
    flags: Partial<FlagKeys>;
    permissions: Partial<PermissionsResponseDTO>;
  };
  params: {
    org: string;
  };
}

// Permission is checked before the flag so an unauthorized reader cannot infer the flag's state.
export const loopIntelligenceBeforeLoad = async ({
  context: {
    flags,
    permissions
  },
  params: {
    org
  }
}: LoopIntelligenceBeforeLoadArgs) => {
  if (!permissions[REQUIRED_PERMISSION]) {
    throw new PermissionDeniedError(REQUIRED_PERMISSION);
  }
  if (!flags.loopIntelligenceEnabled) {
    throw redirect({
      to: '/org/$org',
      params: {
        org
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop-intelligence')({
  beforeLoad: loopIntelligenceBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loopIntelligence.nav)
    }
  }
});